export enum DeployEnvironment {
  LOCAL,
  DEVELOPMENT,
  TEST,
  PRODUCTION,
}
